import { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";

/** >= 1024px: sidebar lateral | < 1024px: tab bar inferior */
export const DESKTOP_BREAKPOINT = 1024;

const LayoutContext = createContext(null);

export const LayoutProvider = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [moreMenuOpen, setMoreMenuOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(
    typeof window !== "undefined" ? window.innerWidth >= DESKTOP_BREAKPOINT : true
  );

  useEffect(() => {
    const handleResize = () => {
      const desktop = window.innerWidth >= DESKTOP_BREAKPOINT;
      setIsDesktop(desktop);
      if (desktop) setMoreMenuOpen(false);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = useCallback(() => {
    setSidebarCollapsed((prev) => !prev);
  }, []);

  const openMoreMenu = useCallback(() => setMoreMenuOpen(true), []);
  const closeMoreMenu = useCallback(() => setMoreMenuOpen(false), []);

  const value = useMemo(
    () => ({
      isDesktop,
      showTabBar: !isDesktop,
      sidebarCollapsed,
      setSidebarCollapsed,
      sidebarExpanded: !sidebarCollapsed,
      toggleSidebar,
      moreMenuOpen,
      openMoreMenu,
      closeMoreMenu,
      setMoreMenuOpen,
    }),
    [isDesktop, sidebarCollapsed, toggleSidebar, moreMenuOpen, openMoreMenu, closeMoreMenu]
  );

  return <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>;
};

export const useLayout = () => {
  const ctx = useContext(LayoutContext);
  if (!ctx) {
    throw new Error("useLayout debe usarse dentro de LayoutProvider");
  }
  return ctx;
};
